 import { Box, Center, Text, VStack } from '@chakra-ui/react';

const RSSpinner = ({hasLoading, stateProps,message}) => {
  const domain = stateProps.domain === undefined ? 'https://rsapp.resumescripter.com' : stateProps.domain;

  let imgSrc = domain + "/app/images/spinners/" + stateProps.spinnerImage;
  if(stateProps.spinnerImage === undefined) {
    imgSrc =  domain + "/app/images/spinners/default.gif";

  }

  return (
    <Center sx={{ flexGrow: 1 }} >
      <VStack zIndex={3} backgroundColor="#ccc" padding="78px 75px" borderRadius="10px">

        <Box  padding=".5rem">
          <Text variant="b24" color="BLACK" fontWeight='bold' opacity='100%' textAlign='center'>
            {stateProps.spinnerMessage}
          </Text>
        </Box>
        <img
          src={imgSrc}
          alt="RS Spinner"
          width="200px"
          height="200px"
          margin="0 75px"
          borderRadius='10px'
        />
        {hasLoading &&
          <>
            <Text variant="b24" color="MAGENTA" opacity='50%'>
              loading...
            </Text>
          </>
        }
      </VStack>
    </Center>
  );
};
/*
          <Text variant="b24" color="MAGENTA" opacity='100%' textAlign='center' fontWeight='bold'>
            Sit tight!
          </Text>
          <Text variant="b24" color="MAGENTA" opacity='100%' textAlign='center'>
            The resume-writing wizards
          </Text>
          <Text variant="b24" color="MAGENTA" opacity='100%' textAlign='center'>
            are hard at work.
          </Text>
 */
 export default RSSpinner;
